import {
  AccountBalanceWallet,
  ContactMail,
  Groups,
  ReceiptLong,
  SupportAgent,
  LocalShipping,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAppSocket } from '../../providers/AppSocketContext';
import { Util } from '../../util/Util';
import { reads, readsTable, situation } from '../../util/access';
import WorkspaceHub, { type HubSection } from './WorkspaceHub';

const PeopleHub = () => {
  const { t } = useTranslation();
  const { appSettings } = useAppSocket();
  const showAgents = Util.isBoolSettingEnabled(appSettings?.UI_ENABLE_AGENTS?.value);

  const cards = [
    {
      id: 'clients',
      title: t('nav:tabs.clients'),
      description: t('common:hubs.cards.clients'),
      path: '/clients',
      grant: situation('client'),
      color: '#1565c0',
      icon: Groups,
    },
    {
      id: 'wallets',
      title: t('nav:tabs.clientWallets'),
      description: t('common:hubs.cards.wallets'),
      path: '/clients/wallets',
      grant: reads('wallet'),
      color: '#2e7d32',
      icon: AccountBalanceWallet,
    },
    {
      id: 'wallet-transactions',
      title: t('nav:tabs.walletTransactions'),
      description: t('common:hubs.cards.walletTransactions'),
      path: '/clients/wallets/transactions',
      grant: reads('wallet'),
      color: '#00838f',
      icon: ReceiptLong,
    },
    {
      id: 'client-addresses',
      title: t('nav:tabs.clientAddresses'),
      description: t('common:hubs.cards.clientAddresses'),
      path: '/clients/addresses',
      grant: readsTable('client_address'),
      color: '#00695c',
      icon: ContactMail,
    },
    {
      id: 'agents',
      title: t('nav:tabs.agents'),
      description: t('common:hubs.cards.agents'),
      path: '/agents',
      grant: situation('agent'),
      color: '#ef6c00',
      icon: SupportAgent,
    },
    {
      id: 'suppliers',
      title: t('nav:tabs.suppliers'),
      description: t('common:hubs.cards.suppliers'),
      path: '/suppliers',
      grant: situation('supplier'),
      color: '#6a1b9a',
      icon: LocalShipping,
    },
  ];

  const sections: HubSection[] = [
    {
      id: 'people',
      cards: showAgents ? cards : cards.filter((card) => card.id !== 'agents'),
    },
  ];

  return (
    <WorkspaceHub
      title={t('nav:tabs.people')}
      subtitle={t('common:hubs.peopleSubtitle')}
      sections={sections}
    />
  );
};

export default PeopleHub;
